import React, { useState } from 'react';
import './contactus.css';
import { db } from '../FirebaseComp/firebase'; // Adjust path
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import emailjs from "emailjs-com";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.message.trim()) newErrors.message = 'Message is required';
    return newErrors;
  };




const handleSubmit = async (e) => {
  e.preventDefault();
  const validationErrors = validate();

  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }

  setIsSubmitting(true);

  try {

    // Save to Firestore
    await addDoc(collection(db, 'contactus'), {
      ...formData,
      createdAt: serverTimestamp()
    });

    // Send Email
    await emailjs.send(
      "service_5x2anhk", // Service ID
      "template_42c152h", // Template ID
      {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        subject: formData.subject,
        message: formData.message
      },
      "d8MPSVybGHqsEvNou" // Public Key
    );

    setSubmitted(true);
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });

    setErrors({});
    setTimeout(() => setSubmitted(false), 5000);

  } catch (error) {
    console.error("Error:", error);
    alert("Submission failed. Try again.");
  } finally {
    setIsSubmitting(false);
  }
};





  return (
    <div className="contactus-container">

      {/* Top Banner */}
      <div className="contact-banner">
        <img src="/footer b.jpeg" alt="Contact Banner" />
        <div className="banner-overlay">
          <h1>Contact <span>ELYSIAN WELLNESS</span></h1>
          <p>Your wellness journey starts here. Reach out to us!</p>
        </div>
      </div>

      <div className="contact-content">

        {/* Contact Info Cards */}
        <div className="contact-info">
          <div className="info-card">
            <i className="fas fa-map-marker-alt"></i>
            <h4>Address</h4>
            <p>No. 31, Tissa Road, Baddalandayaya,<br />Wellawaya, Sri Lanka</p>
          </div>

          <div className="info-card">
            <i className="fas fa-phone-alt"></i>
            <h4>Phone</h4>
            <p>+94 70 554 9750<br />+94 71 270 3920</p>
          </div>

          <div className="info-card">
            <i className="fas fa-envelope"></i>
            <h4>Email</h4>
            <p>info@elisianswellness.lk</p>
          </div>

          <div className="info-card">
            <i className="fas fa-clock"></i>
            <h4>Working Hours</h4>
            <p>Mon-Fri: 8AM - 8PM<br />Sat-Sun: 9AM - 6PM</p>
          </div>
        </div>

        {/* Contact Form */}
        <div className="contact-form-container">
          {submitted ? (
            <div className="success-message">
              <i className="fas fa-check-circle"></i>
              <p>Thank you! We'll get back to you shortly.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label>Name*</label>
                <input type="text" name="name" value={formData.name} onChange={handleChange} className={errors.name ? 'error' : ''} disabled={isSubmitting}/>
                {errors.name && <span className="error-message">{errors.name}</span>}
              </div>

              <div className="form-group">
                <label>Email*</label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} className={errors.email ? 'error' : ''} disabled={isSubmitting}/>
                {errors.email && <span className="error-message">{errors.email}</span>}
              </div>

              <div className="form-group">
                <label>Phone</label>
                <input type="tel" name="phone" value={formData.phone} onChange={handleChange} disabled={isSubmitting}/>
              </div>

              <div className="form-group">
                <label>Subject</label>
                <select name="subject" value={formData.subject} onChange={handleChange} disabled={isSubmitting}>
                  <option value="">Select a subject</option>
                  <option value="booking">Booking Inquiry</option>
                  <option value="treatment">Treatment Information</option>
                  <option value="feedback">Feedback</option>
                  <option value="complaint">Complaint</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label>Message*</label>
                <textarea name="message" rows="5" value={formData.message} onChange={handleChange} className={errors.message ? 'error' : ''} disabled={isSubmitting}></textarea>
                {errors.message && <span className="error-message">{errors.message}</span>}
              </div>

              <button type="submit" className="submit-btn" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          )}
        </div>
      </div>

      {/* Map */}
      <div className="contact-map">
        <iframe
          title="Elysians Wellness Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3958.8788341148525!2d79.92006297499856!3d7.14000749286415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zN8KwMDgnMjQuMCJOIDc5wrA1NScyMS41IkU!5e0!3m2!1ssi!2slk!4v1755059882988!5m2!1ssi!2slk"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

    </div>
  );
}

export default ContactUs;
